import "core-js/modules/esnext.global-this.js";
import * as o from "react";
var l = (null === globalThis || void 0 === globalThis ? void 0 : globalThis.document) ? o.useLayoutEffect : function () {};
export { l as useLayoutEffect };